import { Component, OnInit } from '@angular/core';
import { AngazovanjeRoResenje } from './angazovanje-ro-resenje';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-angazovanje-ro-resenje',
  templateUrl: './angazovanje-ro-resenje.component.html'
})
export class AngazovanjeRoResenjeComponent 
extends BaseModalContainer<AngazovanjeRoResenje>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<AngazovanjeRoResenje>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
